import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAboutUs } from "../store/feature/aboutusSlice"; // Assuming your fetchAboutUs is here
import { AppDispatch, RootState } from "../store";

const About = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { content, loading, error } = useSelector((state: RootState) => state.aboutus);

  // Fetch "About Us" content on component mount
  useEffect(() => {
    dispatch(fetchAboutUs());
  }, [dispatch]);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-6">Hakkımızda</h1>
        </div>
      </section>

      {/* About Us Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">Hakkımızda</h2>
              {loading ? (
                <p className="text-gray-600">Loading...</p>
              ) : error ? (
                <p className="text-red-600">{error}</p>
              ) : (
                <div className="text-gray-600 mb-4 whitespace-pre-line leading-relaxed">
                  {content || "Hakkımızda içeriği buraya görünecek."}
                </div>
              )}
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800"
                alt="Our Team"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
